import { useState } from 'react';
import { formatNumber } from '../../../game/helpers';
import { GreenButton } from './GreenButton';
import { DATA } from '../../../game/data';
import { tryStartAudio } from '../../../game/audio';

export const UpgradeButton: React.FC<{
  icon: string;
  value: string;
  price: number;
  onClick: () => void;
  hasMoney: boolean;
  maxLevel: boolean;
}> = ({ icon, value, price, onClick, hasMoney, maxLevel }) => {
  const canPress = hasMoney && !maxLevel;

  const onButtonClick = () => {
    tryStartAudio();
    if (!canPress) {
      return;
    }
    onClick();
  };

  return (
    <GreenButton onClick={onButtonClick} disabled={!canPress} style={{ flex: 1 }}>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 2,
          fontWeight: 400,
          marginBottom: 4,
          fontSize: '1rem',
        }}
      >
        <img src={icon} alt="Icon" style={{ width: '1rem' }} />
        {value}
      </div>
      <div style={{ fontSize: '1rem', fontWeight: 800 }}>{maxLevel ? 'Max level' : `$${formatNumber(price)}`}</div>
    </GreenButton>
  );
};
